import React from 'react';
import { Button, Modal, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { navigate } from 'gatsby';

//REDUX
import { homeContentActions } from '../../redux/reducers/home.reducers';
import { builderContentActions } from '../../redux/reducers/builder.reducers';

//SVGs
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { WarningFilled } from '@ant-design/icons';

export const BuilderNav = () => {
    //redux
    const dispatch = useDispatch();

    //redux functions
    const { resetStateBuilder } = builderContentActions;
    const { updateListHome, resetStateHome } = homeContentActions;

    //redux non functions
    const { activePage, pageBuilder } = useSelector((state) => state.builderContents);

    //states
    const text = <span>Empty workspace are not allowed</span>;

    //functions
    const handleOpenContactModal = () => {
        dispatch(
            updateListHome({
                builderConfig: {
                    contactOpen: true,
                },
            }),
        );
    };

    const handleSubmitIdea = () => {
        alert('Submited');
    };

    const confirmExit = () => {
        Modal.confirm({
            title: 'Exit Idea Builder?',
            icon: <WarningFilled />,
            content: 'Your current progress will not be saved if you exit now.',
            okText: 'Exit idea builder',
            cancelText: 'Return to builder',
            onOk() {
                dispatch(resetStateBuilder());
                localStorage.setItem('builderMode', false);
                dispatch(resetStateHome());
                navigate('/');
            },
        });
    };

    return (
        <header className="buildernav d-flex-col justify-content-center align-items-center">
            <div className="buildernav_container d-flex-row justify-content-between align-items-center">
                <div className="buildernav_container_left  d-flex-row align-items-center">
                    <Button type="link" onClick={confirmExit}>
                        <div className="d-flex-row align-items-center">
                            <AiOutlineArrowLeft /> <p> Back </p>
                        </div>
                    </Button>
                    <p>Idea Builder</p>
                </div>
                <div className="buildernav_container_right  d-flex-row align-items-center">
                    <Button type="link" onClick={handleOpenContactModal}>
                        Contact Us
                    </Button>
                    {activePage === 'builder' ? (
                        <>
                            {pageBuilder.submitDisabled ? (
                                <>
                                    <Tooltip color="#3cc2dd" placement="bottomRight" title={text}>
                                        <Button type="primary" disabled>
                                            Submit Idea
                                        </Button>
                                    </Tooltip>
                                </>
                            ) : (
                                <Button type="primary" onClick={handleSubmitIdea}>
                                    Submit Idea
                                </Button>
                            )}
                        </>
                    ) : null}
                </div>
            </div>
        </header>
    );
};
